





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class BotonLinkMenu extends Vue {
  @Prop({ default: '' }) titulo!: string;
  @Prop({ default: '' }) link!: string;
  @Prop({ default: '' }) srcs!: string;
  @Prop({ default: '' }) clase!: string;

  map: google.maps.Map;
  infoWindow = new google.maps.InfoWindow({
    content: '',
    disableAutoPan: true,
  });
  locations: any = [];
  labels: any = [];

  mounted() {}
  eventClick(link: string) {
    let routeData = link;

    window.open(routeData, '_blank');
  }
}
